import commonPostTypeConfig from "../../common/postTypes/tag";

export default function initPostType({wapp}) {
    return wapp.client.postTypes.getPostType({
        name: "tag",
        addIfThereIsNot: true,
        statusManager: commonPostTypeConfig.getStatusManager(),
    });
}
